import { FC, useId } from 'react';

import { FastContactForm } from '@/entities/contact/components/FastContactForm';
import { COLORS } from '@/shared/constants/colors';
import { Title } from '@/shared/uikit/Title';
import { Button } from '@/shared/uikitV2/Button';
import { useTranslation } from '@/shared/utils/i18n/useTranslation';
import { BtnClose } from '@/widgets/modals/components/BtnClose';

import { useModalsStore } from '../../modals.store';
import { FastCreateContactProps } from '../../types';

import { Actions, Body, Container, Fields, Header, StyledDrawer } from './styled';

export const FastCreateContactModal: FC<FastCreateContactProps> = ({ onSave, contactType }) => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'fastCreateContact' });
  const modals = useModalsStore();
  const formId = useId();

  const onClose = () => modals.closeModal();

  return (
    <StyledDrawer open={true} closable={false} footer={null} width={400} onClose={onClose}>
      <Container>
        <Header>
          <Title size={22} bold>
            {t('title')}
          </Title>
          <BtnClose onClick={onClose} />
        </Header>
        <Body className="uikitScrollbar">
          <Fields>
            <FastContactForm formId={formId} onClose={onClose} type={contactType} onSave={onSave} />
          </Fields>
        </Body>
        <Actions>
          <Button
            type="text"
            onClick={onClose}
            style={{ color: COLORS.systemSky200, fontWeight: 700 }}
          >
            {t('btnCancel')}
          </Button>
          <Button htmlType="submit" form={formId}>
            {t('btnSave')}
          </Button>
        </Actions>
      </Container>
    </StyledDrawer>
  );
};
